import { createStyles } from '@mui/styles';

// Types
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) =>
   createStyles({
      profileManagementIconButton: {
         padding: '0px',
         "&:hover": {
            backgroundColor: 'transparent',
            cursor: 'pointer'
         }
      },
      profileManagementContainer: {
         '& .MuiMenu-paper': {
            borderTop: '4px solid #2d91e9',
            boxShadow: '0 5px 12px 0 rgba(0, 0, 0, 0.08)',
            maxWidth: '350px',
            top: '83px !important',
            left: 'auto !important',
            right: '35px',
            borderRadius: '0px',
            zIndex: 9999,
         }
      },
      profileDetailsMenuContainer: {
         padding: 25
      },
      profileManagementActiveIcon: {
         backgroundColor: '#2d91e9',
         border: 'solid 2px #2d91e9',
         color: '#ffffff'
      },
      profileManagementInActiveIcon: {
         backgroundColor: 'rgba(255, 255, 255, 0)',
         border: 'solid 2px #4a4a4a',
         color: '#4a4a4a',
         fontSize: '1.5rem'
      },
      profileManagementIcon: {
         width: '38px',
         height: '38px',
         borderRadius: '50%',
         marginLeft: '10px',
         marginRight: '20px',
         '& span': {
            position: 'relative',
            top: 11,
            fontFamily: 'CircularStd',
            fontSize: '16px',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1,
            letterSpacing: '-1px',
         }
      },
      profileManagementUserInfo: {
         marginBottom: '30px',
         '& h6': {
            fontFamily: 'CircularStd',
            fontSize: '15px',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.33,
            letterSpacing: 'normal',
            color: '#4a4a4a',
            margin: '0px'
         },
         '& p': {
            fontFamily: 'CircularStd',
            fontSize: '15px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.33,
            letterSpacing: 'normal',
            color: '#4a4a4a'
         }
      },
      profileManagementMenuWrapper: {
         '& ul': {
            paddingTop: '0px',
            paddingBottom: '0px'
         },
         '& li': {
            '& .MuiListItem-root': {
               paddingTop: '5px',
               paddingBottom: '5px',
               paddingLeft: '10px',
               paddingRight: '10px'
            },
            '& .MuiListItemIcon-root': {
               minWidth: '25px'
            },
            '& .MuiListItemText-root': {
               '& span': {
                  fontFamily: 'CircularStd',
                  fontSize: '14px',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontStyle: 'normal',
                  lineHeight: 1.43,
                  letterSpacing: 'normal',
                  color: '#4a4a4a'
               }
            }
         },
         '& span:last-child': {
            '& .MuiDivider-root': {
               display: 'none'
            }
         }
      },
      switchAccountContainer: {
         display: 'flex',
         padding: '15px 30px',
         flexDirection: 'column',
         alignItems: 'flex-start',
         gap: 10,
         alignSelf: 'stretch',
         background: '#F5F5F5',
         '& h6': {
            fontFamily: 'CircularStd',
            fontSize: '15px',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.33,
            letterSpacing: 'normal',
            color: '#4a4a4a',
            margin: '0px'
         }
      },
      optionItem: {
         display: 'flex',
         padding: 10,
         alignItems: 'center',
         alignSelf: 'stretch',
         borderRadius: 5,
         cursor: 'pointer',
         '&:hover': {
            backgroundColor: '#EAF3FF',
         },
         '& > div > div:first-child': {
            fontSize: 12,
            lineHeight: '16px',
            fontWeight: 400
         },
         '& > div > div:last-child': {
            fontSize: 10,
            lineHeight: '14px',
            fontWeight: 400
         },
         '&[aria-selected="true"]': {
            color: '#FFFFFF',
            backgroundColor: '#2D91E9 !important',
            '& > img:last-child': {
               width: 16,
               height: 16
            }
         }
      },
      accountOptionsContainer: {
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'flex-start',
         gap: 2,
         alignSelf: 'stretch'
      }
   });
